/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */

export type GetBackProcedimentiTipiTipologia =
  (typeof GetBackProcedimentiTipiTipologia)[keyof typeof GetBackProcedimentiTipiTipologia];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBackProcedimentiTipiTipologia = {
  PROCEDIMENTO: 'PROCEDIMENTO',
  ENDOPROCEDIMENTO: 'ENDOPROCEDIMENTO',
  ENTRAMBI: 'ENTRAMBI',
  PRATICA: 'PRATICA',
} as const;
